// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5ee5a636","703":"bc613f86","736":"7bb1063e","787":"8bc74567"}[chunkId] + ".chunk.js";
};